import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PanelLayout from "layouts/PanelLayout";
import "styles/teacher.css";
import { TbSmartHome } from "react-icons/tb";
import { FaTrash } from "react-icons/fa";
import { RiUploadCloudLine } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";

const AddQuestionPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const test = location.state?.test || { title: "Test nomi", questions: [] };

  const [questions, setQuestions] = useState(
    Array.isArray(test.questions) && test.questions.length > 0
      ? test.questions
      : [{ question: "", image: null, options: ["", "", "", ""], correct: 0 }]
  );

  const [active, setActive] = useState(0);

  const handleQuestionChange = (field, value) => {
    const newQuestions = [...questions];
    newQuestions[active][field] = value;
    setQuestions(newQuestions);
  };

  const handleOptionChange = (index, value) => {
    const newQuestions = [...questions];
    newQuestions[active].options[index] = value;
    setQuestions(newQuestions);
  };

  const handleSelectCorrect = (index) => {
    const newQuestions = [...questions];
    newQuestions[active].correct = index;
    setQuestions(newQuestions);
  };

  const handleDelete = () => {
    if (!window.confirm("Bu savolni o‘chirmoqchimisiz?")) return;
    const newQuestions = [...questions];
    newQuestions.splice(active, 1);
    setQuestions(
      newQuestions.length
        ? newQuestions
        : [{ question: "", image: null, options: ["", "", "", ""], correct: 0 }]
    );
    setActive(0);
  };

  const handleAddQuestion = () => {
    setQuestions([
      ...questions,
      { question: "", image: null, options: ["", "", "", ""], correct: 0 },
    ]);
    setActive(questions.length);
  };

  const handleSaveAll = () => {
    navigate("/teacher/tests", {
      state: {
        subject: location.state?.subject,
        updatedTest: {
          ...test,
          questions,
        },
      },
    });
  };

  return (
    <PanelLayout>
      <div className="questions-page">
        <div className="breadcrumb">
          <TbSmartHome
            style={{ fontSize: 20, color: "#01CC0D", cursor: "pointer" }}
            onClick={() => navigate("/teacher")}
          />
          <span className="divider">/</span>
          <span
            onClick={() => navigate("/teacher/tests")}
            style={{ cursor: "pointer" }}
          >
            Testlar
          </span>
          <span className="divider">/</span>
          <span className="current">Savol qo‘shish</span>
        </div>

        <h3 style={{ margin: "15px 0", fontWeight: "600" }}>{test.title}</h3>

        <div className="question-container">
          <div className="question-list">
            {questions.map((_, i) => (
              <button
                key={i}
                className={`q-btn ${active === i ? "active" : ""}`}
                onClick={() => setActive(i)}
              >
                {i + 1}
              </button>
            ))}
            <button className="q-btn add-btn" onClick={handleAddQuestion}>
              +
            </button>
          </div>

          <div className="question-editor">
            <div className="question-header">
              <span>Savol - {active + 1}</span>
              <button className="delete-btn" onClick={handleDelete}>
                <FaTrash size={14} />
              </button>
            </div>

            <div className="question-text-with-upload">
              <textarea
                className="q-text"
                value={questions[active].question}
                placeholder="Savol matnini yozing..."
                onChange={(e) =>
                  handleQuestionChange("question", e.target.value)
                }
              />

              <div
                className="inline-img-upload"
                onClick={() =>
                  document.getElementById(`fileInput-${active}`).click()
                }
              >
                {questions[active].image ? (
                  <>
                    <img
                      src={URL.createObjectURL(questions[active].image)}
                      className="mini-preview"
                      alt=""
                    />
                    <span
                      className="remove-img-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleQuestionChange("image", null);
                      }}
                    >
                      <RxCross2 size={14} />
                    </span>
                  </>
                ) : (
                  <RiUploadCloudLine size={24} />
                )}
              </div>

              <input
                id={`fileInput-${active}`}
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={(e) =>
                  handleQuestionChange("image", e.target.files[0])
                }
              />
            </div>

            <div className="options">
              {questions[active].options.map((opt, i) => (
                <label key={i} className="option">
                  <input
                    type="radio"
                    name={`correct-${active}`}
                    checked={questions[active].correct === i}
                    onChange={() => handleSelectCorrect(i)}
                  />
                  <input
                    type="text"
                    placeholder={`Variant ${i + 1}`}
                    value={opt}
                    onChange={(e) => handleOptionChange(i, e.target.value)}
                  />
                </label>
              ))}
            </div>

            <button className="save-btn" onClick={handleSaveAll}>
              Saqlash
            </button>
          </div>
        </div>
      </div>
    </PanelLayout>
  );
};

export default AddQuestionPage;
